module.exports = __webpack_public_path__ + "img/101.6.21749c72.png";